import ResourcesReducer from './resources_reducer';

export default ResourcesReducer;
